<template>
  <header class="site-header">
    <div class="core-container site-header__inner">
      <router-link to="/" class="site-header__brand">
        <img
          src="@homepage/1748d168bbe53a20b5d0a7ea1edbee1f.jpg"
          alt="懂标帝"
          class="site-header__logo"
        />
      </router-link>

      <nav class="site-header__nav">
        <router-link
          v-for="item in navItems"
          :key="item.label"
          :to="item.path"
          :class="['site-header__nav-item', { 'is-active': isNavActive(item.path) }]"
        >{{ item.label }}</router-link>
      </nav>

      <div class="site-header__actions">
        <template v-if="loggedIn">
          <router-link to="/my-orders" class="site-header__link">我的订单</router-link>
          <button type="button" class="site-header__btn site-header__btn--outline" @click="logout">
            退出
          </button>
        </template>
        <button
          v-else
          type="button"
          class="site-header__btn site-header__btn--outline"
          @click="openLogin"
        >
          登录 / 注册
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import { NAV_ITEMS } from '@/mock/home'

export default {
  name: 'SiteHeader',
  data() {
    return {
      navItems: NAV_ITEMS
    }
  },
  computed: {
    ...mapState(['loggedIn'])
  },
  methods: {
    isNavActive(path) {
      return this.$route.path === path
    },
    openLogin() {
      this.$store.commit('SHOW_LOGIN', this.$route.fullPath)
    },
    logout() {
      this.$store.dispatch('logout', this.$router)
    }
  }
}
</script>

<style scoped>
.site-header {
  height: var(--header-height);
  background: var(--color-bg-page);
  border-bottom: 1px solid var(--color-border-light);
}

.site-header__inner {
  height: 100%;
  display: flex;
  align-items: center;
}

.site-header__brand {
  flex-shrink: 0;
}

.site-header__logo {
  height: 48px;
  width: auto;
  display: block;
}

.site-header__nav {
  flex: 1;
  display: flex;
  align-items: center;
  gap: var(--space-2xl);
  margin-left: var(--header-brand-nav-gap);
}

.site-header__nav-item {
  position: relative;
  font-size: var(--font-size-lg);
  color: var(--color-text-primary);
  padding: var(--space-sm) 0;
  transition: color 0.2s;
}

.site-header__nav-item:hover {
  color: var(--color-nav-active);
}

.site-header__nav-item.is-active {
  color: var(--color-nav-active);
  font-weight: 500;
}

.site-header__nav-item.is-active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(-1 * var(--space-sm));
  height: 3px;
  background: var(--color-nav-active);
  border-radius: var(--radius-pill);
}

.site-header__actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: var(--space-md);
  margin-left: var(--space-xl);
}

.site-header__link {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.site-header__link:hover {
  color: var(--color-primary);
}

.site-header__btn {
  border: none;
  font-size: var(--font-size-md);
  transition: all 0.2s;
}

.site-header__btn--outline {
  padding: var(--space-sm) var(--space-lg);
  background: var(--color-bg-page);
  color: var(--color-text-secondary);
  border: 1px solid #b0b8e0;
  border-radius: var(--radius-pill);
}

.site-header__btn--outline:hover {
  border-color: var(--color-primary);
  color: var(--color-primary);
}
</style>
